module.exports = __webpack_public_path__ + "img/shenzihong.64501dda.png";